<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{ action }}</div>
    <div slot="body">
      <dialog-selected-tips :name="$t('common_198')" :count="params.data.length" :action="action" />
      <dialog-table :data="params.data" :columns="params.columns.slice(0, 3)" />
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'
import { uuid } from '@/utils/utils'
import { WORKFLOW_TYPES } from '@/constants/workflow'

export default {
  name: 'WorkflowCloneDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      action: this.$t('common.clone'),
    }
  },
  created () {
    this.resOrderSetM = new this.$Manager('resource_order_sets')
  },
  methods: {
    async handleConfirm () {
      this.loading = true
      const { variables: initVariables = {}, process_definition_key = '' } = this.params.data[0]
      try {
        const variables = {
          process_definition_key,
          initiator: initVariables.initiator,
          description: initVariables.description,
          project: initVariables.project,
          project_domain: initVariables.project_domain,
        }
        if (process_definition_key === WORKFLOW_TYPES.EXECUTE_RESOURCE_ORDER_SET && initVariables.ids) {
          // 克隆一份购物车订单
          const { displayname, name } = this.$store.getters.userInfo
          const orderName = this.$t('common.shopcart_workflow_name', [displayname || name, this.$moment().format('YYYY-MM-DD'), uuid()])
          const resOrderSetM = await this.resOrderSetM.performAction({
            id: initVariables.ids,
            action: 'clone',
            data: {
              name: orderName,
            },
          })
          if (resOrderSetM.data && resOrderSetM.data.id) {
            variables.ids = resOrderSetM.data.id
            variables.parameter = '{}'
          }
        } else {
          if (initVariables.ids) {
            variables.ids = initVariables.ids
          }
          if (initVariables.paramter) {
            variables.paramter = initVariables.paramter
          }
          if (initVariables.parameter) {
            variables.parameter = initVariables.parameter
          }
        }
        if (initVariables['server-create-paramter']) {
          variables['server-create-paramter'] = initVariables['server-create-paramter']
        }
        if (initVariables.price) {
          variables.price = initVariables.price
        }
        if (initVariables.serverConf) {
          variables.serverConf = initVariables.serverConf
        }
        await new this.$Manager('process-instances', 'v1').create({ data: { variables } })
        this.loading = false
        this.params.success()
        this.cancelDialog()
      } catch (error) {
        this.loading = false
        throw error
      }
    },
  },
}
</script>
